import api from './client';

export interface GeoRouterRule {
  campaign_id: string;
  countries: string[];
}

export interface GeoRouter {
  id: string;
  name: string;
  domain_id: string;
  slug: string;
  rules: GeoRouterRule[];
  default_campaign_id: string | null;
  fallback_url: string | null;
  status: 'active' | 'paused';
  created_by_admin_id: string | null;
  created_at: string;
  updated_at: string;
}

export type GeoRouterInput = Pick<GeoRouter, 'name' | 'domain_id' | 'rules' | 'default_campaign_id' | 'fallback_url' | 'status'> & { slug?: string };

export const getGeoRouters = () => api.get<GeoRouter[]>('/admin/tracker/geo-routers');
export const createGeoRouter = (data: GeoRouterInput) => api.post<GeoRouter>('/admin/tracker/geo-routers', data);
export const updateGeoRouter = (id: string, data: Partial<GeoRouterInput>) => api.put<GeoRouter>(`/admin/tracker/geo-routers/${id}`, data);
export const deleteGeoRouter = (id: string) => api.delete<{ message: string }>(`/admin/tracker/geo-routers/${id}`);
